export enum ChannelType {
    ASSETS = 'assets',
}

export enum ChannelEvent {
    RENDITION_UPDATE = 'rendition-update',
}
